//
// Welcome Dialog Overlay
// Displays a welcome message overlay when the page loads
//

class WelcomeDialog {
    constructor(config = {}) {
        this.overlay = null;
        this.isShown = false;
        this.config = {
            title: config.title || null, // Allow null/undefined for no title
            body: config.body || 'Welcome to our website!',
            showDialog: config.showDialog !== false,
            delay: config.delay || 500,
            storageKey: config.storageKey || 'welcomeDialogShown'
        };
        
        if (this.config.showDialog) {
            this.init();
        }
    }

    init() {
        // Create the overlay HTML
        this.createOverlay();
        
        // Add event listeners
        this.addEventListeners();
        
        // Show dialog on page load (with small delay)
        setTimeout(() => {
            this.show();
        }, this.config.delay);
    }

    createOverlay() {
        // Create overlay container
        this.overlay = document.createElement('div');
        this.overlay.className = 'welcome-dialog-overlay';
        
        // Create dialog content with optional title
        const titleHtml = this.config.title ? `<h2>${this.config.title}</h2>` : '';
        
        this.overlay.innerHTML = `
            <div class="welcome-dialog">
                <button title="Close" class="welcome-dialog-close">×</button>
                ${titleHtml}
                <div>
                    <div class="welcome-dialog-body">${this.config.body}</div>
                </div>
                <div>
                    <button class="welcome-dialog-button">Close</button>
                </div>
            </div>
        `;
        
        // Add to body
        document.body.appendChild(this.overlay);
    }

    addEventListeners() {
        // Close button (×)
        const closeBtn = this.overlay.querySelector('.welcome-dialog-close');
        closeBtn.addEventListener('click', () => this.hide());
        
        // Close button (text)
        const closeButton = this.overlay.querySelector('.welcome-dialog-button');
        closeButton.addEventListener('click', () => this.hide());
        
        // Click outside dialog to close
        this.overlay.addEventListener('click', (e) => {
            if (e.target === this.overlay) {
                this.hide();
            }
        });
        
        // ESC key to close
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.isShown) {
                this.hide();
            }
        });
    }

    show() {
        if (!this.isShown) {
            this.overlay.classList.add('show');
            this.isShown = true;
            document.body.style.overflow = 'hidden'; // Prevent scrolling
        }
    }

    hide() {
        if (this.isShown) {
            this.overlay.classList.remove('show');
            this.isShown = false;
            document.body.style.overflow = ''; // Restore scrolling
            
            // Store in localStorage so it doesn't show again for this session
            localStorage.setItem(this.config.storageKey, 'true');
        }
    }
}

// Initialize welcome dialog when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    // Check if welcome dialog configuration exists (set by Umbraco)
    if (window.umbracoWelcomeDialog && window.umbracoWelcomeDialog.showDialog) {
        // Only show if not already shown in this session
        const storageKey = window.umbracoWelcomeDialog.storageKey || 'welcomeDialogShown';
        if (!localStorage.getItem(storageKey)) {
            new WelcomeDialog(window.umbracoWelcomeDialog);
        }
    }
});

// Also export for manual usage
export default WelcomeDialog;
